import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspMyRequestComponent } from './asp-my-request.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationPipesModule } from 'app/main/applicationPipesModule.module';



import { MatProgressBarModule } from '@angular/material/progress-bar';

const routes: Routes = [
  {
      path: 'my-request',
      component: AspMyRequestComponent,
  },
];

@NgModule({
  declarations: [AspMyRequestComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    BrowserModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    ApplicationPipesModule,
    

    
  ],
  
  exports: [AspMyRequestComponent,RouterModule],
})
export class AspMyRequestModule { }
